import { makeEntityScaffold } from '@classpass/saga-tools';
export var isUserVerified = makeEntityScaffold('SAGA.API.IS_USER_VERIFIED', function (client, options) {
  return client.phoneVerification.isUserVerified(options).catch(function (err) {
    if (err.httpStatus === 404) {
      return false;
    }

    throw err;
  });
});